/**
 * @function getTabName
 * @async
 * @param { string } id
 * @param { Array } tabs
 * @returns { Promise<string> } tabName
 */
function getTabName(id, tabs) {
	let tabName = '';

	for (let i = 0; i < tabs.length; i++) {
		if (tabs[i].id === id) {
			tabName = tabs[i].name;
		}
	}
	return tabName;
}

export default getTabName;
